import { strokeStyle } from "./stroke";

// Mock `Оновити звіти` (prototype.html, page-head): an arrow up into a tray.
function UploadIcon({ color = "var(--accent-solid)" }) {
  return (
    <svg
      aria-hidden="true"
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={strokeStyle(color)}
    >
      <path d="M12 3v12M7 8l5-5 5 5M4 21h16" />
    </svg>
  );
}

export default UploadIcon;
